'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$$anon$185() {
  this.ce8 = null;
  this.ce6 = null;
  this.ce7 = false;
  this.ce4 = null;
  this.ce5 = false;
  this.ce9 = false;
  this.cea = false;
  this.ce8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$$anon$185 as $c_Lpresto_types$proto$$anon$185 };
$p = $c_Lpresto_types$proto$$anon$185.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$$anon$185;
/** @constructor */
function $h_Lpresto_types$proto$$anon$185() {
}
export { $h_Lpresto_types$proto$$anon$185 as $h_Lpresto_types$proto$$anon$185 };
$h_Lpresto_types$proto$$anon$185.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.ce8;
});
$p.t = (function() {
  if ((!this.ce7)) {
    this.ce6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ce7 = true;
  }
  return this.ce6;
});
$p.ad = (function() {
  if ((!this.ce5)) {
    this.ce4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().a2r(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.ce5 = true;
  }
  return this.ce4;
});
$p.v = (function() {
  if ((!this.cea)) {
    this.ce9 = false;
    this.cea = true;
  }
  return this.ce9;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$$anon$185 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$$anon$185, "presto.types$proto$$anon$185", ({
  a3i: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$$anon$185 as $d_Lpresto_types$proto$$anon$185 };
//# sourceMappingURL=presto.types$proto$$anon$185.js.map
